module.exports = __webpack_public_path__ + "static/Pt18-d0a7ec59643d96d09863cc0e6691beb8.jpg";